var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSimpleArrowRight = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8.48 14.14",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m1.41 14.14 7.07-7.07L1.41 0 0 1.42l5.66 5.65L0 12.73z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSimpleArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/simple-arrow-right.086071c4150d5e6d0f028620b187cf97.svg";